<template>
  <div class="sidebar-header" v-if="customer">
    {{ customer.name }}
  </div>
</template>
<script>

export default {
  name: 'sidebar-header',
  data() {
    return {
      customer : this.$store.getters.getCustomer
    }
  }
}
</script>
